<div class="modal-content">
  <div class="modal__content">
    <div class="modal__header">
      <h3 class="h3 modal__title">
        {{ 'sharedModule.bkgAlternativeOfferDialog.title' | translate }}
      </h3>
      <button
        (click)="onClickClose()"
        type="button"
        class="modal__close"
        data-bs-dismiss="modal"
        aria-label="Cerrar"
      >
        <img src="assets/images/icons/close.svg" />
      </button>
    </div>
    <div *ngIf="showInfo" class="alternative-product__card-info-container">
      <img src="assets/images/icons/info.svg" />
      <span>
        {{
          'sharedModule.bkgAlternativeOfferDialog.infoTooltip'
            | translate: { description: description }
        }}
      </span>
      <img
        (click)="switchShowInfo()"
        src="assets/images/icons/close-inverse.svg"
      />
    </div>
    <div class="modal__body">
      <p>
        {{ body }}
      </p>
      <div class="alternative-product__card">
        <div class="parking-extra__icon">
          <img src="assets/images/parking-external.svg" />
        </div>
        <div class="alternative-product__card-text">
          {{ name }} {{ alternativeName }}
          <span>
            {{ 'sharedModule.bkgAlternativeOfferDialog.newPrice' | translate }}

            {{ price | number: '1.0-2' }} {{ 'common.euro' | translate }}</span
          >
        </div>

        <div>
          <img
            class="alternative-product__card-info-icon"
            (click)="switchShowInfo()"
            src="assets/images/icons/info.svg"
          />
        </div>
      </div>

      <button
        (click)="onClickBooking()"
        type="button"
        id="bkgAlternativeOfferDialogBtn"
        class="btn-primary"
      >
        {{ 'sharedModule.bkgAlternativeOfferDialog.booking' | translate }}
      </button>
      <div (click)="onClickRedirectStepTwo()" class="link">
        <a>
          {{
            'sharedModule.bkgAlternativeOfferDialog.changesDatesOrProduct'
              | translate
          }}
        </a>
      </div>
    </div>
  </div>
</div>
